import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import "./styles.css";
import "./env-dump.ts";
import reportWebVitals from "./reportWebVitals.ts";
import { initMsal } from "@/auth/msal.ts";
import { Providers } from "@/components/Providers.tsx";

async function bootstrap() {
  await initMsal();

  const rootElement = document.getElementById("app");
  if (!rootElement)
    throw new Error('Root-Element mit id="app" nicht gefunden.');

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <Providers />
    </StrictMode>,
  );
}

void bootstrap();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
